// src/store/ApiPara/actions.js
import * as types from './types';

// Update ApiPara
export const updateApiPara = data => (dispatch, getState) => {
  try {
    dispatch({
      type: types.API_PARA_UPDATE_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    });
  } catch (error) {
    dispatch({
      type: types.API_PARA_UPDATE_FAILURE,
      payload: error
    });
  }
};

// Clear ApiPara
export const clearApiPara = () => (dispatch, getState) => {
  try {
    dispatch({
      type: types.API_PARA_CLEAR_SUCCESS,
      async: true,
      payload: {}, // reset ApiPara
      state: getState()
    });
  } catch (error) {
    dispatch({
      type: types.API_PARA_CLEAR_FAILURE,
      payload: error
    });
  }
};
